module.exports = __webpack_public_path__ + "static/media/icon-logout.8879b450.svg";